import React, {
  useState,
  useEffect
} from "react";

import {
  useNavigate,
  useParams
} from "react-router-dom";

import Editor from "../../../components/admin/Editor";

import "./AddBlog.css";
import { BACKEND_URL } from "../../../config";

function EditBlog() {

  const navigate = useNavigate();

  const { id } = useParams();

  const [saving, setSaving] =
    useState(false);

  const [imagePreview, setImagePreview] =
    useState(null);

  const [file, setFile] =
    useState(null);

  const [keywordInput, setKeywordInput] =
    useState("");

  const [keywordList, setKeywordList] =
    useState([]);

  const [faqList, setFaqList] = useState([]);


  const [form, setForm] = useState({
  title: "",
  slug: "",
  description: "",
  metatitle: "",
  metadescription: "",
  keywords: "",
  faq: "",
  author: "",
  date: "",
  status: "published",
  image: "",
});

  // ==========================================
  // FETCH BLOG
  // ==========================================

  useEffect(() => {

    fetch(
      `${BACKEND_URL}/api.php?module=blog`
    )
      .then((res) => res.json())
      .then((data) => {

        if (data.success) {

          const blog =
            data.data.find(
              (b) =>
                String(b.id) === String(id)
            );

        if (blog) {

          setForm(blog);

          if (blog.faq) {

            try {
              setFaqList(JSON.parse(blog.faq));
            } catch {
              setFaqList([]);
            }

          }

          if (blog.keywords) {

            setKeywordList(
              blog.keywords
                .split(",")
                .map(k => k.trim())
            );

          }

          if (blog.image) {

            setImagePreview(
              `${BACKEND_URL}/${blog.image}`
            );

          }

        }

                }

              });

          }, [id]);




const removeFaq = (index) => {

  setFaqList(
    faqList.filter((_, i) => i !== index)
  );

};


const updateFaq = (index, field, value) => {

  const updated = [...faqList];

  updated[index][field] = value;

  setFaqList(updated);

};

  // ==========================================
  // AUTO SLUG
  // ==========================================

  useEffect(() => {

    const generatedSlug =
      form.title
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s-]/g, "")
        .replace(/\s+/g, "-");

    setForm((prev) => ({
      ...prev,
      slug: generatedSlug,
    }));

  }, [form.title]);

  // ==========================================
  // INPUT CHANGE
  // ==========================================

  const handleChange = (e) => {

    const { name, value } = e.target;

    setForm({
      ...form,
      [name]: value,
    });

  };

  // ==========================================
  // KEYWORDS
  // ==========================================

  const handleKeywordKeyDown = (e) => {

    if (
      e.key === "Enter" ||
      e.key === ","
    ) {

      e.preventDefault();

      const value =
        keywordInput.trim();

      if (
        value &&
        !keywordList.includes(value)
      ) {

        const updated = [
          ...keywordList,
          value,
        ];

        setKeywordList(updated);

        setForm({
          ...form,
          keywords: updated.join(","),
        });

      }

      setKeywordInput("");

    }

  };

  // ==========================================
  // REMOVE KEYWORD
  // ==========================================

  const removeKeyword = (index) => {

    const updated =
      keywordList.filter(
        (_, i) => i !== index
      );

    setKeywordList(updated);

    setForm({
      ...form,
      keywords: updated.join(","),
    });

  };

  // ==========================================
  // UPDATE BLOG
  // ==========================================

 const handleUpdate = async (e) => {

  e.preventDefault();

  setSaving(true);

  try {

    const formData = new FormData();

    formData.append("action", "update");

    formData.append("id", form.id);

    formData.append("title", form.title);

    formData.append("slug", form.slug);

    formData.append(
      "description",
      form.description
    );

    formData.append(
      "metatitle",
      form.metatitle
    );

    formData.append(
      "metadescription",
      form.metadescription
    );

    formData.append(
  "keywords",
  keywordList.join(",")
);

    formData.append(
      "author",
      form.author
    );

    formData.append(
      "date",
      form.date
    );

    formData.append(
  "faq",
  JSON.stringify(faqList)
);

    formData.append(
      "status",
      form.status
    );

    // IMPORTANT FIX
    formData.append(
      "old_image",
      form.image || ""
    );


    // NEW IMAGE
    if (file) {

      formData.append(
        "image",
        file
      );
    }

    const response =
      await fetch(
        `${BACKEND_URL}/api.php?module=blog`,
        {
          method: "POST",
          body: formData,
        }
      );

    const result =
      await response.json();

    if (result.success) {

      alert(
        "Blog Updated Successfully ✔"
      );

      navigate("/admin/blog");

    } else {

      alert(
        result.message ||
          "Update Failed"
      );
    }

  } catch (error) {

    console.log(error);

  } finally {

    setSaving(false);
  }
};

  return (

    <div className="add-blog-page">

      <h2>
        Edit Blog
      </h2>

      <form
        className="blog-form"
        onSubmit={handleUpdate}
      >

        {/* TITLE */}

        <label>
          Title
        </label>

        <input
          type="text"
          name="title"
          value={form.title}
          onChange={handleChange}
        />

        {/* SLUG */}

        <label>
          Slug
        </label>

        <input
          type="text"
          name="slug"
          value={form.slug}
          onChange={handleChange}
        />

        {/* DESCRIPTION */}

        <label>
          Description
        </label>

        <Editor
          formData={form}
          setFormData={setForm}
          field="description"
        />

        {/* META TITLE */}

        <label>
          Meta Title
        </label>

        <input
          type="text"
          name="metatitle"
          value={form.metatitle}
          onChange={handleChange}
        />

        {/* META DESCRIPTION */}

        <label>
          Meta Description
        </label>

        <textarea
          name="metadescription"
          value={form.metadescription}
          onChange={handleChange}
        />

        {/* KEYWORDS */}

        <label>
          Keywords
        </label>

        <input
          type="text"
          placeholder="keyword + Enter"
          value={keywordInput}
          onChange={(e) =>
            setKeywordInput(
              e.target.value
            )
          }
          onKeyDown={
            handleKeywordKeyDown
          }
        />

        <div className="keyword-box">

          {keywordList.map(
            (k, i) => (

              <span
                key={i}
                className="keyword-tag"
                onClick={() =>
                  removeKeyword(i)
                }
              >
                {k} ✖
              </span>

            )
          )}

        </div>

        {/* FAQ */}

        <h3>FAQ</h3>

        {faqList.map((item, index) => (

          <div
            key={index}
            className="faq-box"
          >

            <label>Question</label>

            <input
              value={item.question}
              onChange={(e) => {

                const updated = [...faqList];

                updated[index].question =
                  e.target.value;

                setFaqList(updated);

              }}
            />

            <label>Answer</label>

            <input
              value={item.answer}
              onChange={(e) => {

                const updated = [...faqList];

                updated[index].answer =
                  e.target.value;

                setFaqList(updated);

              }}
            />

            <button
              type="button"
              onClick={() => {

                const updated =
                  faqList.filter(
                    (_, i) => i !== index
                  );

                setFaqList(updated);

              }}
            >
              ❌ Remove
            </button>

          </div>

        ))}

        <button
          type="button"
          onClick={() => {

            setFaqList([
              ...faqList,
              {
                question: "",
                answer: "",
              },
            ]);

          }}
        >
          ➕ Add FAQ
        </button>

        {/* AUTHOR */}

        <label>
          Author
        </label>

        <input
          type="text"
          name="author"
          value={form.author}
          onChange={handleChange}
        />

        {/* DATE */}

        <label>
          Date
        </label>

        <input
          type="date"
          name="date"
          value={form.date}
          onChange={handleChange}
        />


        <label>Status</label>

        <select
          name="status"
          value={form.status}
          onChange={handleChange}
        >

          <option value="published">
            Published
          </option>

          <option value="draft">
            Draft
          </option>

        </select>

        {/* IMAGE */}

        <label>
          Blog Image
        </label>

        <input
          type="file"
          accept=".webp,image/webp"
          onChange={(e) => {

            const img =
              e.target.files[0];

            if (img) {

              if (
                img.type !==
                "image/webp"
              ) {

                alert(
                  "Only WEBP images allowed "
                );

                return;

              }

              setFile(img);

              setImagePreview(
                URL.createObjectURL(
                  img
                )
              );

            }

          }}
        />

        {imagePreview && (

          <img
            src={imagePreview}
            alt=""
            width="180"
            style={{
              marginTop: "10px",
              borderRadius: "10px",
            }}
          />

        )}

        {/* BUTTON */}

        <div className="blog-buttons">

          <button
            type="button"
            className="draft-btn"
            disabled={saving}
            onClick={() => {
              setForm(prev => ({
                ...prev,
                status: "draft"
              }));

              setTimeout(() => {
                document
                  .querySelector(".blog-form")
                  .requestSubmit();
              }, 50);
            }}
          >
            Save Draft
          </button>

          <button
            type="submit"
            className="publish-btn"
            disabled={saving}
            onClick={() =>
              setForm(prev => ({
                ...prev,
                status: "published"
              }))
            }
          >
            {saving ? "Updating..." : "Update Blog"}
          </button>

        </div>
      </form>

    </div>

  );

}

export default EditBlog;